import { render, staticRenderFns } from "./SelectModuleInstructions.vue?vue&type=template&id=4778cc08"
import script from "./SelectModuleInstructions.vue?vue&type=script&lang=js"
export * from "./SelectModuleInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports